(function(s){var w,f={},o=window,l=console,m=Math,z='postMessage',x='HackTimer.js by turuslan: ',v='Initialisation failed',p=0,r='hasOwnProperty',y=[].slice,b=o.Worker;function d(){do{p=0x7FFFFFFF>p?p+1:0}while(f[r](p));return p}if(!/MSIE 10/i.test(navigator.userAgent)){try{s=o.URL.createObjectURL(new Blob(["var f={},p=postMessage,r='hasOwnProperty';onmessage=function(e){var d=e.data,i=d.i,t=d[r]('t')?d.t:0;switch(d.n){case'a':f[i]=setInterval(function(){p(i)},t);break;case'b':if(f[r](i)){clearInterval(f[i]);delete f[i]}break;case'c':f[i]=setTimeout(function(){p(i);if(f[r](i))delete f[i]},t);break;case'd':if(f[r](i)){clearTimeout(f[i]);delete f[i]}break}}"]))}catch(e){}}if(typeof(b)!=='undefined'){try{w=new b(s);o.setInterval=function(c,t){var i=d();f[i]={c:c,p:y.call(arguments,2)};w[z]({n:'a',i:i,t:t});return i};o.clearInterval=function(i){if(f[r](i))delete f[i],w[z]({n:'b',i:i})};o.setTimeout=function(c,t){var i=d();f[i]={c:c,p:y.call(arguments,2),t:!0};w[z]({n:'c',i:i,t:t});return i};o.clearTimeout=function(i){if(f[r](i))delete f[i],w[z]({n:'d',i:i})};w.onmessage=function(e){var i=e.data,c,n;if(f[r](i)){n=f[i];c=n.c;if(n[r]('t'))delete f[i]}if(typeof(c)=='string')try{c=new Function(c)}catch(k){l.log(x+'Error parsing callback code string: ',k)}if(typeof(c)=='function')c.apply(o,n.p)};w.onerror=function(e){l.log(e)};l.log(x+'Initialisation succeeded')}catch(e){l.log(x+v);l.error(e)}}else l.log(x+v+' - HTML5 Web Worker is not supported')})('HackTimerWorker.min.js');

const animateElements = document.querySelectorAll('.changing-text-wrapper');

let intervalID = null;
const IntervalManager = function(reset, animate, time){
    if(!reset)
      intervalID =  setInterval(animate, time);
    else
      clearInterval(intervalID);
 }

const appHeight = () => {
    document.documentElement.style.setProperty('--app-height', window.innerHeight+'px' );
}
appHeight();

const animateText = () => {
    for (let i = 0; i < intervalID; i++){
        clearInterval(i);
    }
    animateElements.forEach(function(animateElement){
        const innerEl = animateElement.querySelector('.changing-text');

        animateElement.querySelectorAll('.changing-text').forEach(function(el) {
            el.classList.remove('active');
        });
        innerEl.firstElementChild.classList.add('active');
        innerEl.style.transform = `translateY(0)`;
        let currentEl = animateElement.querySelector('.active');
        animateElement.style.height = `${currentEl.offsetHeight}px`;
        let ypos=0;

        const animate = () => {
            currentEl = animateElement.querySelector('.active');
            nextEl = currentEl.nextElementSibling ?? innerEl.firstElementChild;
            animateElement.style.height = `${ nextEl.offsetHeight }px`;

            ypos = currentEl.nextElementSibling ? currentEl.offsetHeight : 0;
            innerEl.style.transform = `translateY(${ypos*-1}px)`;
            
            innerEl.classList.add('animating');
            currentEl.classList.remove('active');
            nextEl.classList.add('active');
            setTimeout(function(){
                innerEl.classList.remove('animating');
                innerEl.appendChild(currentEl);
                innerEl.style.transform = `translateY(0px)`;
            }, 1000);
        }
        IntervalManager(false, animate, 4000);  // for setInterval

        
    })
}
animateText();

const windowWidth = window.innerWidth;
window.onresize = () => {

    if(this.innerWidth != windowWidth){
        animateText();
    }else{
        if(window.outerWidth > 768){
            appHeight();
        }
    }
}
